import { render, staticRenderFns } from "./SettingsPersonalView.vue?vue&type=template&id=70a727c4&"
import script from "./SettingsPersonalView.vue?vue&type=script&lang=ts&"
export * from "./SettingsPersonalView.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsPersonalView.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports